import { render, staticRenderFns } from "./DownloadArtifactLinkColumn.vue?vue&type=template&id=e6fb9786&"
import script from "./DownloadArtifactLinkColumn.vue?vue&type=script&lang=js&"
export * from "./DownloadArtifactLinkColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports